import { Center, Text, CenterProps } from '@chakra-ui/react';

type ActiveProps = { day: number } & CenterProps;

export default function Active({ day, ...props }: ActiveProps) {
  return (
    <Center bgColor="primary" borderRadius="5px" py={4} {...props}>
      <Text color="white" fontWeight="bold">
        {day}
      </Text>
    </Center>
  );
}
